/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc
 */
import * as References from './PortalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#placeholderMethod
 */
export const PLACEHOLDER_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_placeholderMethod';
export const PLACEHOLDER_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: PLACEHOLDER_METHOD_QUERY_FIELD_NAME,
  args: ['domain', 'cookie', 'requestField'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.placeholderMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#loginVerifyAnnotated
 */
export const LOGIN_VERIFY_ANNOTATED_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_loginVerifyAnnotated';
export const LOGIN_VERIFY_ANNOTATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOGIN_VERIFY_ANNOTATED_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.loginVerifyAnnotatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#loginVerify
 */
export const LOGIN_VERIFY_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_loginVerify';
export const LOGIN_VERIFY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOGIN_VERIFY_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.loginVerifyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#authenticatedPortalMethod
 */
export const AUTHENTICATED_PORTAL_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_authenticatedPortalMethod';
export const AUTHENTICATED_PORTAL_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: AUTHENTICATED_PORTAL_METHOD_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.authenticatedPortalMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#dynamicCompanyFetchPortalMethod
 */
export const DYNAMIC_COMPANY_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_dynamicCompanyFetchPortalMethod';
export const DYNAMIC_COMPANY_FETCH_PORTAL_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DYNAMIC_COMPANY_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.dynamicCompanyFetchPortalMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#dynamicProjectFetchPortalMethod
 */
export const DYNAMIC_PROJECT_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_dynamicProjectFetchPortalMethod';
export const DYNAMIC_PROJECT_FETCH_PORTAL_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DYNAMIC_PROJECT_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.dynamicProjectFetchPortalMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#dynamicProjectsFetchPortalMethod
 */
export const DYNAMIC_PROJECTS_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_dynamicProjectsFetchPortalMethod';
export const DYNAMIC_PROJECTS_FETCH_PORTAL_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DYNAMIC_PROJECTS_FETCH_PORTAL_METHOD_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.dynamicProjectsFetchPortalMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#updatePreferredLanguage
 */
export const UPDATE_PREFERRED_LANGUAGE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_updatePreferredLanguage';
export const UPDATE_PREFERRED_LANGUAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PREFERRED_LANGUAGE_MUTATION_FIELD_NAME,
  args: ['language', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.updatePreferredLanguageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#getCourses
 */
export const GET_COURSES_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_getCourses';
export const GET_COURSES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COURSES_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getCoursesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#getCourseDetail
 */
export const GET_COURSE_DETAIL_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_getCourseDetail';
export const GET_COURSE_DETAIL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COURSE_DETAIL_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getCourseDetailRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#getLessonContent
 */
export const GET_LESSON_CONTENT_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_getLessonContent';
export const GET_LESSON_CONTENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LESSON_CONTENT_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getLessonContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#getMyLearning
 */
export const GET_MY_LEARNING_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_getMyLearning';
export const GET_MY_LEARNING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MY_LEARNING_QUERY_FIELD_NAME,
  args: ['message', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getMyLearningRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#lookupItem
 */
export const LOOKUP_ITEM_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_lookupItem';
export const LOOKUP_ITEM_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LOOKUP_ITEM_QUERY_FIELD_NAME,
  args: ['itemId'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.lookupItemRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc#slowTestMethod
 */
export const SLOW_TEST_METHOD_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_reference_be_rpc_PortalRpc_slowTestMethod';
export const SLOW_TEST_METHOD_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SLOW_TEST_METHOD_QUERY_FIELD_NAME,
  args: ['domain', 'cookie', 'requestField'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.slowTestMethodRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});